import { createContext } from 'react'

interface JobPageType {
  jobName: string
  jobId: string
  parentDomainId?: string
  hasHomes: boolean
}

const initialJobPageContext: JobPageType = {
  jobName: '',
  jobId: '',
  parentDomainId: '',
  hasHomes: false,
}

export const JobPageContext = createContext<JobPageType>(initialJobPageContext)
